import styled from 'styled-components'
import {Link, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {useCookies} from 'react-cookie'
import Checkbox from "../../components/common/Checkbox";
import {findIdParams, findIdResult, findPasswordParams, loginParams, tokenResultAtom} from "./entity";
import {login} from "../../services/auth/AuthAxios";
import {atom, useAtom, useSetAtom} from "jotai";
import {modalController} from "../../store";
import {useForm} from "react-hook-form";
import {RowSpan, TextMainColor, ValidationScript} from "../../assets/GlobalStyles";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {selChangePassword, selFindUserId} from "../../services/platform/ManageUserAxios";
import {ComponentModalFindId, ComponentModalFindPassword} from "../../components/modal";
import {logo, logo_inline_w} from "../../constants/GlobalConst";
export const FindIdResultAtom = atom(findIdResult)

function FindPassword(props) {
  const [findPasswordInfo, setFindPasswordInfo] = useState(findPasswordParams)
  const navigate = useNavigate()
  const {register, handleSubmit, formState:{errors}} = useForm()

  const handleFindPassword = () => {
    //axios 로 호출하여 서버쪽에서 이메일쪽으로 전송
    selChangePassword(findPasswordInfo).then(response => {
        if(response){
          //성공
          props.openModal(findPasswordInfo)
        }else{
          toast.warning('입력하신정보가 회원정보와 일치 하지 않습니다')
        }
    })
  }
  /**
   * 담당자 이메일
   * @param event
   */
  const handleManagerEmail = (event) =>{
    setFindPasswordInfo({
      ...findPasswordInfo,
      email: event.target.value
    })
  }
  /**
   * 담당자 연락처
   * @param event
   */
  const handleManagerPhone = (event) =>{
    setFindPasswordInfo({
      ...findPasswordInfo,
      phone: event.target.value
    })
  }
  /**
   * 담당자 아이디
   * @param event
   */
  const handleMemberId = (event) =>{
    setFindPasswordInfo({
      ...findPasswordInfo,
      username: event.target.value
    })
  }

  const onSubmit = (data) => {
    handleFindPassword()
  }

  const onError = () => console.log(errors)

  return (
    <LoginInputComponent>
      <Title>
        <h1>비밀번호 찾기</h1>
      </Title>
      <form onSubmit={handleSubmit(onSubmit,onError)}>
      <InputGroup>
        <LabelInline>
          <span>아이디</span>
        </LabelInline>
        <div>
          <input type={'text'}
                 placeholder={'아이디를 입력 해주세요'}
                 value={findPasswordInfo.username}
                 {...register('username',{
                   required: "아이디를 입력 해주세요",
                   onChange:(e) => handleMemberId(e)
                 })}
          />
        </div>
        {errors.username && <ValidationScript>{errors.username.message}</ValidationScript>}
      </InputGroup>
      <InputGroup>
        <LabelInline>
          <span>담당자 연락처</span>
        </LabelInline>
        <FindCorporationNo>
          <input type={'text'}
                 placeholder={'연락처를 입력해주세요'}
                 value={findPasswordInfo.phone}
                 {...register('phone',{
                   required: "연락처를 입력해주세요",
                   pattern:{
                     value: /[0-9]{10,11}/g,
                     message: "숫자만 입력해주세요"
                   },
                   onChange:(e) => handleManagerPhone(e)
                 })}
          />
        </FindCorporationNo>
        {errors.phone && <ValidationScript>{errors.phone.message}</ValidationScript>}
      </InputGroup>
      <InputGroup>
        <LabelInline>
          <span>담당자 이메일</span>
        </LabelInline>
        <div>
          <input type={'text'}
                 placeholder={'담당자 이메일을 입력해주세요.'}
                 value={findPasswordInfo.email}
                 onChange={(e) => handleManagerEmail(e)}
                 {...register('email',{
                   required: "이메일을 입력해주세요,",
                   pattern: {
                     value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                     message: "이메일 형식을 확인해주세요"
                   },
                   onChange:(e) => handleManagerEmail(e)
                 })}
          />
        </div>
        {errors.email && <ValidationScript>{errors.email.message}</ValidationScript>}
      </InputGroup>
      <FindGroup />
      <InputGroup style={{display: 'flex', gap: 10}}>
        <Button type={'button'} $secondary onClick={() => navigate('/')}>
           로그인
        </Button>
        <Button type={'submit'}>
          비밀번호 찾기
        </Button>
      </InputGroup>
      </form>
    </LoginInputComponent>
  )
}

function FindId(props) {
  const [findIdInfo, setFindIdInfo] = useState(findIdParams)
  const [,setFindIdResult] = useAtom(FindIdResultAtom)
  const navigate =useNavigate()
  const {register, handleSubmit, formState:{errors}} = useForm()
  const success = true
  const handleFindId = () => {
    if(success){
      selFindUserId(findIdInfo).then(response => {
        setFindIdResult(response)
      })
      props.openModal()
    } else{
      toast.info('등록된 아이디나 이메일이 없습니다.')
    }
  }

  /**
   * 담당자 이메일
   * @param event
   */
  const handleManagerEmail = (event) =>{
    setFindIdInfo({
      ...findIdInfo,
      email: event.target.value
    })
  }
  /**
   * 담당자 연락처
   * @param event
   */
  const handleManagerPhone = (event) =>{
    setFindIdInfo({
      ...findIdInfo,
      phone: event.target.value
    })
  }
  const onSubmit = (data) => {
    handleFindId()
  }

  const onError = () => console.log(errors)

  return (
    <LoginInputComponent>
      <Title>
        <h1>아이디 찾기</h1>
      </Title>
      <form onSubmit={handleSubmit(onSubmit,onError)}>
      <InputGroup>
        <LabelInline>
          <span>담당자 연락처</span>
        </LabelInline>
        <FindCorporationNo>
          <input type={'text'}
                 placeholder={'연락처를 입력해주세요'}
                 value={findIdInfo.phone}
                 {...register('phone',{
                   required: "연락처를 입력해주세요",
                   pattern:{
                     value: /[0-9]{10,11}/g,
                     message: "숫자만 입력해주세요"
                   },
                   onChange:(e) => handleManagerPhone(e)
                 })}
          />
        </FindCorporationNo>
        {errors.phone && <ValidationScript>{errors.phone.message}</ValidationScript>}
      </InputGroup>
      <InputGroup>
        <LabelInline>
          <span>담당자 이메일</span>
        </LabelInline>
        <div>
          <input type={'text'}
                 placeholder={'담당자 이메일을 입력해주세요.'}
                 value={findIdInfo.email}
                 {...register('email',{
                   required: "담당자 이메일을 입력해주세요",
                   pattern: {
                     value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                     message: "이메일 형식을 확인해주세요"
                   },
                   onChange:(e) => handleManagerEmail(e)
                 })}
          />
        </div>
        {errors.email && <ValidationScript>{errors.email.message}</ValidationScript>}
      </InputGroup>
      <FindGroup />
        <InputGroup style={{display: 'flex', gap: 10}}>
          <Button type={'button'} $secondary onClick={() => navigate('/')}>
            로그인
          </Button>
        <Button type={'submit'}>
          아이디찾기
        </Button>
      </InputGroup>
      </form>
    </LoginInputComponent>
  )
}
function LoginComponent () {
  const [loginParamsValue, setLoginParams] = useState(loginParams);
  const [isRemember, setIsRemember] = useState(false)
  const [cookies, setCookie, removeCookie] = useCookies(['rememberId'])
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate();
  const [,setTokenResult] = useAtom(tokenResultAtom)
  const {register,setValue, handleSubmit, formState:{errors}} = useForm()

  /**
   * 사용자 아이디 입력
   * @param event
   */
  const handleChangeId = (event) => {
    setLoginParams({
      ...loginParamsValue,
      username:event.target.value
    })
    setValue('username',event.target.value)
    if(isRemember){
      setCookie('rememberId', event.target.value)
    }
  }
  /**
   * 사용자 패스원드
   * @param event
   */
  const handleChangePassword = (event) => {
    setLoginParams({
      ...loginParamsValue,
      password:event.target.value
    })
  }

  /**
   * 아이디 저장 Cookie 이용
   * @param event
   */
  const handleChangeRemember = (event) => {
    setIsRemember(event.target.checked)
    if(event.target.checked) {
      setCookie('rememberId', loginParamsValue.username)
    } else {
      removeCookie('rememberId')
    }
  }

  /**
   * 쿠키에 아이디 저장 삭제
   */
  useEffect(() => {
    if (cookies.rememberId !== undefined) {
      setLoginParams(prev => ({
        ...prev,
        username: cookies.rememberId,
      }));

      setValue('username', cookies.rememberId);
      setIsRemember(true);
    }
  }, [cookies.rememberId, setValue]);

  /**
   * 로그인
   */
  const onSubmit = () => {
    login(loginParamsValue).then(response => {
      if(response){
        if (response === 'C007') { //비활성화 계정
          toast.info('회원님의 계정이 비활성화되었습니다. 담당자에게 문의해 주시기 바랍니다.')
        } else {
          setTokenResult({
            id:response.id,
            role:response.role,
            name:response.name,
            username:response.username,
            accessToken: response.token.accessToken,
            refreshToken: response.token.refreshToken
          })
          navigate('/board/dashboard')
        }
        // if (response.data.isTermsAgree) {
        //   // go to main
        //   navigate("/")
        // } else {
        //   navigate("/termsAgree")
        // }
      } else toast.info('아이디와 비밀번호를 확인해 주세요.')
    });
  }
  const onError = (error) => console.log(error)

  return (
    <LoginInputComponent>
      <Title>
        <h1><BlockLogo/></h1>
      </Title>
      <RowSpan style={{justifyContent: 'flex-end'}}>
        <TextMainColor>사용자 로그인</TextMainColor>
        <HorizontalRule />
        <Link to={'/adminLogin'}>관리자 로그인</Link>
      </RowSpan>
      <form onSubmit={handleSubmit(onSubmit,onError)}>
      <InputGroup>
        <LabelInline>
          <span>아이디</span>
          <Checkbox
            onChange={handleChangeRemember}
            isChecked={isRemember}
            label={'아이디 저장'}
            type={'a'}/>
        </LabelInline>
        <div>
          <input
            type={'text'}
            placeholder={'아이디'}
            maxLength={20}
            value={loginParamsValue.username || ''}
            {...register('username',{
              required: "아이디를 입력해주세요",
              onChange: (e) => {
                handleChangeId(e)
              }
            })}/>
        </div>
        {errors.username && <ValidationScript>{errors.username.message}</ValidationScript>}
      </InputGroup>
      <InputGroup>
        <LabelInline>
          <span>비밀번호</span>
        </LabelInline>
        <div style={{position: 'relative'}}>
          <input
            maxLength={16}
            style={{padding: '15px 40px 15px 15px'}}
            type={!showPassword ? 'password' : 'text'}
            placeholder={'비밀번호(8~16자)'}
            value={loginParamsValue.password || ''}
            {...register("password", {
              required: "비밀번호를 입력해주세요",
              pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{8,20}$/,
                message: "비밀번호를 확인해주세요. 대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)"
              },
              onChange:handleChangePassword
            })}/>
          <ShowPassword
            style={showPassword ? {backgroundImage: "url('/assets/images/login/hide.png')"} : {backgroundImage: "url('/assets/images/login/show.png')"}}
            onClick={() => setShowPassword(!showPassword)}/>
        </div>
        {errors.password && <ValidationScript>{errors.password?.message}</ValidationScript>}
      </InputGroup>
      <FindGroup>
        <Link to={'/findId'}>아이디찾기</Link>
        <HorizontalRule/>
        <Link to={'/findPassword'}>비밀번호 찾기</Link>
        <HorizontalRule/>
        <Link to={'/signUp'}>회원가입</Link>
      </FindGroup>
      <InputGroup>
        <Button type={'submit'}>
          Login
        </Button>
      </InputGroup>
      </form>
    </LoginInputComponent>
  )
}

function Login(props){
  const setModal = useSetAtom(modalController)
  const handleModalFindId = () => {
    setModal({
      isShow: true,
      width: 500,
      modalComponent: () => {
        return <ComponentModalFindId/>
      }
    })
  }

  const handleModalFindPassword = (passwordParams) => {
    setModal({
      isShow: true,
      width: 500,
      modalComponent: () => {
        return <ComponentModalFindPassword params={passwordParams}/>
      }
    })
  }
  const LoginText = () => {
    if(props.match === 'findId' || props.match === 'findPassword'){
      return <>
        <div>{props.match === 'findPassword' ? "비밀번호" : "아이디"} 찾기가 불가한 회원님들께서는</div>
        <div>고객센터(070-1234-1234)로 연락 주시기 바랍니다.</div>
      </>
    } else {
      return <>
        <div>로그인 하시면 Oaple의</div>
        <div>다양한 서비스를 이용하실 수 있습니다.</div>
      </>
    }
  }
  return (
    <>
      <LoginContainer>
        <div>
          <div>
            <LoginLogo/>
            <div>
              <LoginText/>
              {/*{location.pathname === '/findId' && location.pathname === '/findPassword'?*/}
              {/*  <>*/}
              {/*    <div>{location.pathname === '/findPassword' ? "비밀번호" : "아이디"} 찾기가 불가한 회원님들께서는</div>*/}
              {/*    <div>고객센터(070-1234-1234)로 연락 주시기 바랍니다.</div>*/}
              {/*  </>*/}
              {/*  :*/}
              {/*  <>*/}
              {/*    <div>로그인 하시면 아이엠의</div>*/}
              {/*    <div>다양한 서비스를 이용하실 수 있습니다.</div>*/}
              {/*  </>*/}
              {/*}*/}
            </div>
          </div>
        </div>
        <div>
          {props.match === 'findId' &&
            <FindId openModal={()=>handleModalFindId()}/>
          }
          {props.match === 'findPassword' &&
            <FindPassword openModal={(e)=>handleModalFindPassword(e)}/>
          }
          {props.match === 'login' &&
            <LoginComponent />
          }
        </div>
      </LoginContainer>
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
    </>
  )
}

export default Login

const LoginContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f5f6f8;

  & > div:first-child {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48%;
    min-height: 100vh;
    overflow: hidden;
    background:
      radial-gradient(circle at 18% 18%, rgba(255,255,255,.16) 0 80px, transparent 81px),
      radial-gradient(circle at 82% 78%, rgba(255,255,255,.1) 0 150px, transparent 151px),
      linear-gradient(rgb(32, 36, 43) 0%, rgb(25, 28, 34) 100%);
    text-align: center;

    &::after {
      position: absolute;
      right: -90px;
      bottom: -110px;
      width: 330px;
      height: 330px;
      border: 1px solid rgba(255,255,255,.16);
      border-radius: 50%;
      content: "";
    }

    & > div {
      position: relative;
      z-index: 1;
    }

    & div > div:last-child {
      margin-top: 14px;

      & div {
        color: rgba(255,255,255,.9);
        font-size: var(--font-size-14);
        line-height: 1.7;
      }
    }
  }

  & > div:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52%;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 34px;
  }

  @media (max-width: 860px) {
    & > div:first-child {
      display: none;
    }

    & > div:last-child {
      width: 100%;
      padding: 20px;
    }
  }
`

const FindGroup = styled.div`
  margin: 22px 0 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  a {
    color: #64748b;
    font-size: var(--font-size-12);
    text-decoration: none;
  }

  a:hover {
    color: ${({theme}) => theme.color.subColor};
  }
`

const HorizontalRule = styled.span`
  display: inline-block;
  width: 1px;
  height: 10px;
  background-color: #777;
`

const Title = styled.div`
  text-align: center;

  & h1 {
    margin: 0 0 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const LoginLogo = styled.div`
  width: 250px;
  height: 92px;
  background-image: url(${logo_inline_w});
  background-image: -webkit-image-set(url(${logo_inline_w}) 1x, url(${logo_inline_w}) 2x, url(${logo_inline_w}) 3x);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

const BlockLogo = styled.div`
  width: 128px;
  height: 58px;
  background-image: url(${logo});
  background-image: -webkit-image-set(url(${logo}) 1x, url(${logo}) 2x, url(${logo}) 3x);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

const LoginInputComponent = styled.div`
  width: min(100%, 390px);
  box-sizing: border-box;
  padding: 32px 34px 30px;
  border-top: 7px solid #1c2027;
  border-radius: 12px;
  background: var(--color-surface);
  box-shadow: 0 12px 34px rgba(31, 41, 55, .08);

  & > div:nth-child(2) {
    min-height: 34px;
    margin-bottom: 10px;
  }

  & > div:nth-child(2) a,
  & > div:nth-child(2) span {
    font-size: var(--font-size-12);
    text-decoration: none;
  }

  @media (max-width: 480px) {
    padding: 26px 22px;
  }
`

const InputGroup = styled.div`
  position: relative;
  margin: 18px 0 0;

  & input[type='text'], input[type='email'], input[type='password'] {
    width: 100%;
    height: 42px;
    box-sizing: border-box;
    padding: 0 13px;
    border: 1px solid #dbe3ef;
    background-color: var(--color-surface);
    border-radius: 7px;
    color: #1e293b;
    font-family: inherit;
    font-size: var(--font-size-13);
    outline: 0;
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  & input:focus {
    border-color: ${({theme}) => theme.color.subColor};
    box-shadow: 0 0 0 3px ${({theme}) => theme.color.subColorOpacity5};
  }

  & input[type='checkbox'] + label {
    font-size: var(--font-size-12);
    color: #777
  }
`

const Button = styled.button `
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 1px solid ${({theme, $secondary}) => $secondary ? '#dfe3e7' : theme.color.subColor};
  border-radius: 7px;
  color: ${({$secondary}) => $secondary ? '#666e76' : 'var(--color-surface)'};
  background-color: ${({theme, $secondary}) => $secondary ? 'var(--color-surface)' : theme.color.subColor};
  font-family: inherit;
  font-size: var(--font-size-14);
  font-weight: 800;
  cursor: pointer;
  box-shadow: ${({theme, $secondary}) => $secondary ? 'none' : `0 6px 14px ${theme.color.subColorOpacity20}`};
  transition: background-color .15s ease, border-color .15s ease, transform .15s ease;

  &:hover {
    background-color: ${({theme, $secondary}) => $secondary ? '#f5f7fa' : theme.color.mainColor};
    border-color: ${({theme, $secondary}) => $secondary ? theme.color.subColor : theme.color.mainColor};
    transform: translateY(-1px);
  }
`

const FindCorporationNo = styled.div`
  display: flex;
  align-items: center;
`


const ShowPassword = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 42px;
  height: 42px;
  background-image: url('/assets/images/login/hide.png');
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  cursor: pointer;
`

const LabelInline = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  color: #334155;
  font-size: var(--font-size-13);
  font-weight: 700;
`

